import { Component, inject, OnDestroy, OnInit } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { AppLayoutService } from '../../../core/services/app-layout.service';
import { MatIcon } from '@angular/material/icon';
import { TrackingService } from '../../../core/services/tracking.service';
import { MatomoTrackingCategory } from '../../../enums/matomo-tracking-category.enum';
import { MatomoTrackingAction } from '../../../enums/matomo-tracking-action.enum';

@Component({
  selector: 'app-not-found-page',
  imports: [TranslatePipe, MatButton, RouterLink, MatIcon],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPage implements OnInit, OnDestroy {
  private layoutService: AppLayoutService = inject(AppLayoutService);
  private _trackingService: TrackingService = inject(TrackingService);

  ngOnInit() {
    this.layoutService.hideFullLayout();
    this._trackingService.trackEvent(
      MatomoTrackingCategory.TRACKING_NOT_FOUND,
      MatomoTrackingAction.TRACKING_ERROR,
      `404 REDIRECT`,
    );
  }

  ngOnDestroy() {
    // Crucial: Bring the layout back when navigating away
    this.layoutService.showFullLayout();
  }
}
